import type { IconSvgObject } from './types';

const VolumeMinusIcon: IconSvgObject = [
  ["path", { d: "M17.5 12H21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.5 8.5H4.5C3.39543 8.5 2.5 9.39543 2.5 10.5V13.5C2.5 14.6046 3.39543 15.5 4.5 15.5H7.5L14.5 20V4L7.5 8.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default VolumeMinusIcon;
